
import { Component, Vue } from 'vue-property-decorator';
import LocationList from '@/components/LocationList.vue';

@Component<Locations>({
	components: {
		LocationList
	}
})
export default class Locations extends Vue {
}
